// List of supported formats: https://developers.google.com/drive/api/v3/ref-export-formats
export enum FILES_EXPORT_FORMATS {
	WordDocument = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}
